import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import cloneDeep from 'lodash/cloneDeep';
export default {
  props: {
    form: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      data: {},
      tableData: [],
      tableDataAll: [],
      page: 1,
      pageSize: 10,
      total: 0,
      sli: 0,
      parObj: {},
      records: {}
    };
  },
  watch: {
    form: {
      handler: function handler() {
        this.dataBind();
      },
      immediate: true
    }
  },
  methods: {
    onSubimt: function onSubimt() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.saveGoods(_this.parObj);

              case 2:
                return _context.abrupt("return", true);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    currentChange: function currentChange(e) {
      if (e == 1) {
        this.tableData = this.tableDataAll.slice(this.sli, this.sli + 10);
      } else {
        this.tableData = this.tableDataAll.slice(this.sli + 10 * (e - 1), this.sli + 10 * e);
      }
    },
    dataBind: function dataBind() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res, res2, resolve, sellAttributes, params;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$api.goodsDetails({
                  goodsId: _this2.form.goodsId
                });

              case 2:
                res = _context2.sent;
                _context2.next = 5;
                return _this2.$api.getGoodsStocks({
                  goodsId: _this2.form.goodsId
                });

              case 5:
                res2 = _context2.sent;
                console.log('res2', res2);
                _this2.records = res2;
                resolve = cloneDeep(res);
                resolve.goodsItems.forEach(function (v) {
                  v['goodsItemValue'] = v.itemSellAttributes.map(function (m) {
                    return m.itemValue;
                  }).join(',');
                });
                sellAttributes = resolve.sellAttributeList.map(function (v) {
                  return _objectSpread(_objectSpread({}, v), {}, {
                    items: v.items.map(function (m) {
                      return {
                        sellAttributeId: v.sellAttributeId,
                        sellAttributeItemId: m.sellAttributeItemId,
                        itemValue: m.itemValue,
                        itemSort: m.itemSort,
                        selected: m.validItemIds.length > 0
                      };
                    })
                  });
                });
                params = _objectSpread(_objectSpread({}, resolve), {}, {
                  sellAttributes: sellAttributes
                });
                _this2.parObj = params;
                _this2.tableDataAll = resolve.goodsItems;
                _this2.total = _this2.tableDataAll.length;
                _this2.tableData = _this2.tableDataAll.slice(0, 10);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    handleChange: function handleChange(e) {
      this.parObj.goodsItems.forEach(function (a) {
        if (a.goodsItemId == e.goodsItemId) {
          a.goodsStock = e.goodsStock;
        }
      });
    }
  }
};